export const ar_AR = {
    "PREFIX": {
        "QUESTION": "سؤال",
        "QUESTION-PART": "جزء السؤال",
        "PRE-RELEASE": "مسبق",
        "JOURNAL": "دفتر"
    },
    "CONTENT": {
        "MARK": "{{(totalMarks >= 3 && totalMarks <= 10) && 'علامات' || 'علامة'}}"
    }
};